<template>
    <div slot="no-body" class="border-0 shadow-none border-solid border-1 md:w-2/3 lg:w-full" cardBackground="">

      <div class="text-center lg:mx-8 my-2">
        Are you looking to improve your skills but worried about the cost? At Improvee.io, we understand the financial challenges that students face, which is why we're proud to offer discounted pricing just for you.

      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      // Component data here
    }
  },
  methods: {
    // Component methods here
  },
  computed: {
    // Computed properties here
  },
  mounted() {
    // Code that runs when the component is mounted to the DOM
  }
}
</script>
